module.exports = __webpack_public_path__ + "static/Daesun-0b88b39b0a0e549feb6c84fcb5ca81e0.svg";